import React from 'react'

import ContentImage from '../ContentImage'

const ContentText = ({ text }) => {
  const textElements = text
    .replace(/(?!\\n)<img/g, '\n<img')
    .split('\n')
    .filter(item => item)
  return textElements.map((value, index) => {
    if (value.startsWith('<img')) {
      value.replace('”', '"')
      const regex = /<img.*?src="(.*?)"/
      const url = regex.exec(value)[1]
      return <ContentImage isNarrow image={{ url }} key={index} />
    }

    return value
  })
}

export default ContentText
